import { render, staticRenderFns } from "./ApplicationTeacher.vue?vue&type=template&id=0c2bf736&scoped=true&"
import script from "./ApplicationTeacher.vue?vue&type=script&lang=js&"
export * from "./ApplicationTeacher.vue?vue&type=script&lang=js&"
import style0 from "./ApplicationTeacher.vue?vue&type=style&index=0&id=0c2bf736&prod&lang=scss&"
import style1 from "./ApplicationTeacher.vue?vue&type=style&index=1&id=0c2bf736&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c2bf736",
  null
  
)

export default component.exports